module.exports = __webpack_public_path__ + "img/logo.3960cf14.png";